import {createRoot} from 'react-dom/client';
import mapboxgl from 'mapbox-gl';
import {stripPrefix} from '../../utils/utils.ts';

interface TramInfo {
  model: string;
}
const htmlText = (vehicleId: string, model: string | undefined) =>
  `
          <style>
          .popup-container {
            font-family: Arial, sans-serif;
            padding: 10px;
            border-radius: 8px;
          }
          .popup-table {
            width: 100%;
            border-spacing: 0;
            border-collapse: collapse;
          }
          .bold {
            font-weight: bold;
          }
          .tram-btn {
            cursor: pointer;
            color: #0066cc;
            font-weight: bold;
            padding-top: 8px;
            transition: background-color 0.2s ease, color 0.2s ease, text-decoration 0.2s ease;
            text-decoration: none;
          }

          .tram-btn:hover {
            background-color: #f0f7ff;
            color: #004499;
            border-radius: 4px;
            text-decoration: underline;
          }

          .tram-btn:active {
            background-color: #dceeff;
            color: #003377;
            text-decoration: underline;
          }

          .tram-btn.clicked {
            color: #9900cc;
            text-decoration: underline;
          }
          .green {
            color: green;
          }
          .pointer {
            cursor: pointer;
          }
          .red {
            color: red;
          }
          .align-right {
            text-align: right;
          }
          .padding-top {
            padding-top: 8px;
          }
          .link {
            color: #0066cc;
          }
          .progress-bar-bg {
            background-color: lightgray;
            width: 100px;
            height: 10px;
            border-radius: 5px;
            display: inline-block;
            position: relative;
          }
          .padding-left {
            padding-left: 5px;
          }
          </style>
          <div class="popup-container">
            <table class="popup-table">
              <tr>
               <td class="padding-top bold">Spårvagn ID: ${stripPrefix(vehicleId)}</td>
              </tr>
               <tr>
               <td class="padding-top bold">Modell: ${model}</td>
              </tr>
              <tr>
               <td id="tram-btn-${vehicleId}" class="tram-btn" class="padding-top bold"><a>Följ spårvagn</a></td>
              </tr>
            </table>
          </div>
          `;

export const createTramPopup = (
  vehicleId: string,
  tramInfo: TramInfo | null,
  onFollow: (vehicleId: string) => void,
): mapboxgl.Popup => {
  const container = document.createElement('div');
  const root = createRoot(container);

  const popup = new mapboxgl.Popup().setHTML(htmlText(vehicleId, tramInfo?.model));
  // .setDOMContent(container);

  popup.on('open', () => {
    const el = popup.getElement();
    el?.querySelector(`#tram-btn-${vehicleId}`)?.addEventListener('click', (e) => {
      e.stopPropagation();
      onFollow(vehicleId);
      popup.remove();
    });
  });

  popup.on('close', () => root.unmount());

  return popup;
};
